module.exports = __webpack_public_path__ + "img/Kc.e9fdf9f7.png";